export default "__VITE_ASSET__DBmZHgle__"